import './preakness/style';
import FormStructure from './preakness/form_structure';

export default FormStructure;